import { icon } from '@carvana/ds-styles';
import { AlertCircle, CheckCircle2 } from 'lucide-react';
import { useLocationContext } from '~/context/common/LocationContext';
import { Copy, OptionTitle, OptionWrapper } from './ModalContent.styles';

export default function DefaultAvailabilityOptions() {
  const { isDeliveryAllowed, pickUpInfoToDisplay } = useLocationContext();

  const { pickupLocation, milesToPickupLocation } = pickUpInfoToDisplay ?? {};
  const pickupInfo = `${pickupLocation?.city}, ${pickupLocation?.state} (${milesToPickupLocation} miles away)`;

  return (
    <div
      className="flex flex-wrap gap-lg"
      data-testid="Default Availability Options Wrapper"
    >
      <OptionWrapper className="basis-[190px]">
        <OptionTitle>
          {!pickUpInfoToDisplay && (
            <AlertCircle color={icon.warning} size={16} />
          )}
          Pickup
        </OptionTitle>
        {pickUpInfoToDisplay ? (
          <Copy>{`The nearest pickup location is ${pickupInfo}.`}</Copy>
        ) : (
          <Copy>Pickup is unavailable in your location.</Copy>
        )}
      </OptionWrapper>

      <OptionWrapper className="basis-[190px]">
        <OptionTitle>
          {isDeliveryAllowed ? (
            <CheckCircle2 color={icon.primary} size={16} />
          ) : (
            <AlertCircle color={icon.warning} size={16} />
          )}
          Delivery
        </OptionTitle>
        {isDeliveryAllowed ? (
          <Copy>Delivery is available in your location.</Copy>
        ) : (
          <Copy>Delivery is unavailable in your location.</Copy>
        )}
      </OptionWrapper>
    </div>
  );
}
